// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"293b779b","239":"fc19a5f0","455":"64511e8b"}[chunkId] + ".chunk.js";
};